import React from 'react';
import { Button } from '../';
import { technicalDefinitionLanguageLabel } from '../../helpers';
import { copyToClipboard } from '../../helpers';

import './CodeToolbar.css';

/**
 * The row above a code editor: what is being shown on the left, the copy action on the right.
 *
 * Shared by the technical definition panel and the query modals so the two cannot drift. The left
 * side is a slot rather than a fixed control: the technical definition puts its compiled/raw
 * selector there, and everything else falls back to naming the language, which is more use than an
 * empty half of a row.
 *
 * @param {object} props
 * @param {string} [props.language] - the editor's language, named on the left when `children` is
 *   not given
 * @param {string} [props.copyText] - what the copy button puts on the clipboard; omit for no button
 * @param {React.ReactNode} [props.children] - shown on the left instead of the language
 */
export const CodeToolbar = ({ language, copyText, children }) => (
  <div className="CodeToolbar main-toolbar space-between">
    <div className="code-toolbar-status">
      {children || (
        <span className="code-toolbar-language">{technicalDefinitionLanguageLabel(language)}</span>
      )}
    </div>

    {copyText !== undefined && (
      <Button
        type="button"
        className="main-toolbar-item"
        onClick={() => copyToClipboard(copyText)}
        tooltip="Copy query to clipboard"
        value="Copy"
        valueClicked="Copied!"
      />
    )}
  </div>
);
